import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = [];

function handleEditOrganizationRequest(
  state: State,
  { planzone }: Boundaries["editOrganization"]["request"],
): State {
  const index = state.findIndex((req) => req.planzone.uuid === planzone.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { ...state[index], request: setRequestStateToPending() },
        ...state.slice(index + 1),
      ]
    : [...state, { planzone, request: setRequestStateToPending() }];
}

function handleEditOrganizationSuccess(
  state: State,
  { planzone }: Boundaries["editOrganization"]["success"],
): State {
  const index = state.findIndex((req) => req.planzone.uuid === planzone.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { ...state[index], request: setRequestStateToSuccess() },
        ...state.slice(index + 1),
      ]
    : [...state, { planzone, request: setRequestStateToSuccess() }];
}

function handleEditOrganizationFailure(
  state: State,
  { planzone }: Boundaries["editOrganization"]["failure"],
): State {
  const index = state.findIndex((req) => req.planzone.uuid === planzone.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { ...state[index], request: setRequestStateToFailure() },
        ...state.slice(index + 1),
      ]
    : [...state, { planzone, request: setRequestStateToFailure() }];
}

const reduceState = createStateReducer(initialState, {
  [events.editOrganizationRequested]: handleEditOrganizationRequest,
  [events.editOrganizationSucceeded]: handleEditOrganizationSuccess,
  [events.editOrganizationFailed]: handleEditOrganizationFailure,
});

export type { State, Selector };

export { reduceState, initialState, createSelector };
